<template>
  <Alert
    type="warning"
    v-if="browserTimezone !== timezone"
    class="tw-rounded-none"
  >
    <!-- prettier-ignore -->
    <template #description>
      Your time zone has changed from
      <span class="tw-font-medium">{{ timezone }}</span>
      to
      <span class="tw-font-medium">{{ browserTimezone }}</span>.
      <button class="tw-link" @click="synchroniseTimezone">Synchronise!</button>
      It is best practice to set your time zone setting to match your current
      time.
      <a href="https://www.growthmentor.com/faq/" target="_blank" class="tw-link">Learn more</a>.
    </template>
  </Alert>
</template>

<script setup>
import Alert from '@/shared/components/Alert.vue'
import { useForm } from '@inertiajs/vue3'
import { computed } from 'vue'
import { useCurrentUser } from '@/shared/composables/useCurrentUser'
import { notify } from '@kyvg/vue3-notification'

const { timezone } = useCurrentUser()
const form = useForm({})

const browserTimezone = computed(
  () => Intl.DateTimeFormat().resolvedOptions().timeZone,
)

const synchroniseTimezone = () => {
  form
    .transform(() => ({
      timezone: browserTimezone.value,
    }))
    .put('/settings/profile/basic/sync_timezone', {
      preserveScroll: true,
      onSuccess: () => {
        notify({
          type: 'success',
          text: `Your timezone has been updated to ${browserTimezone.value}. Your page will be reloaded to synchronise your changes.`,
        })

        // TIMEZONE SYNCHRONISATION: Reload the entire page to update all components to use the new timezone.
        setTimeout(() => {
          window.location.reload()
        }, 2000)
      },
    })
}
</script>
